// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","person":"noResultsContact_person__KMbj4","imageWrapper":"noResultsContact_imageWrapper__JZZf9","image":"noResultsContact_image__NLqh2"};